import React from "react";

const WIDTHS = ["w-3/4", "w-1/2", "w-5/6", "w-2/3"];

interface CardSkeletonProps {
  fields: number;
  cards?: number;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ fields, cards = 3 }) => (
  <>
    {Array.from({ length: cards }).map((_, cardIndex) => (
      <li
        key={cardIndex}
        aria-hidden
        className="dark:bg-cream-950 flex w-full flex-col gap-4 rounded-2xl bg-white p-5 shadow"
      >
        <div className="bg-cream-300 dark:bg-cream-700 h-5 w-1/2 animate-pulse rounded" />
        <div className="divide-cream-200 dark:divide-cream-800 flex flex-col divide-y">
          {Array.from({ length: fields }).map((_, fieldIndex) => (
            <div
              key={fieldIndex}
              className="flex items-center justify-between gap-4 py-3 first:pt-0 last:pb-0"
            >
              <div className="bg-cream-300 dark:bg-cream-700 h-4 w-24 animate-pulse rounded" />
              <div
                className={`bg-cream-300 dark:bg-cream-700 h-4 ${WIDTHS[(cardIndex + fieldIndex) % WIDTHS.length]} max-w-40 animate-pulse rounded`}
              />
            </div>
          ))}
        </div>
      </li>
    ))}
  </>
);

export default CardSkeleton;
